module.exports = __webpack_public_path__ + "img/02d.bbbec131.png";